/**
 * One pipe for every customer newsletter form: password page Join,
 * sidebar popup, and any other marked form.
 *
 * Posts to Shopify /contact without a page refresh so a password-page
 * signup cannot trip the site overlay via ?customer_posted=true.
 */
(function () {
  if (window.themeNewsletterBound) return;
  window.themeNewsletterBound = true;

  var SUCCESS_POPUP = 'Successful submission';
  var ERROR_GENERIC = 'Please try again.';

  function isAjaxNewsletter(form) {
    if (form.hasAttribute('data-newsletter-ajax')) return true;
    if (form.id === 'newsletterPopupForm') return true;
    return !!(
      form.classList.contains('password-inline-form') &&
      form.querySelector('input[name="contact[email]"]')
    );
  }

  function contactUrl(form) {
    var action = form.getAttribute('action') || '/contact';
    return action.split('#')[0] || '/contact';
  }

  function payload(form) {
    var data = new FormData(form);
    if (!data.get('form_type')) data.set('form_type', 'customer');
    if (!data.get('utf8')) data.set('utf8', '✓');
    if (!data.get('contact[accepts_marketing]')) {
      data.set('contact[accepts_marketing]', 'true');
    }
    data.delete('customer[accepts_marketing]');
    if (!data.get('contact[tags]')) data.set('contact[tags]', 'newsletter');
    return data;
  }

  function subscribe(form, retry) {
    return fetch(contactUrl(form), {
      method: 'POST',
      body: payload(form),
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (response.status === 429 && !retry) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(subscribe(form, true));
          }, 1600);
        });
      }
      if (response.ok || response.status === 0 || response.type === 'opaqueredirect') {
        return response;
      }
      throw new Error('signup-failed');
    });
  }

  function interpolate(template, email) {
    var copy = (template || '').trim();
    var address = email || 'you';
    if (copy.indexOf('*EMAIL HERE*') !== -1) {
      return copy.split('*EMAIL HERE*').join(address);
    }
    if (!copy || /we.ll notify you when the store is updated\.?/i.test(copy)) {
      return "We'll notify '" + address + "' when the store is updated.";
    }
    return copy;
  }

  function successTemplate(form) {
    var row = form.querySelector('[data-password-email-row]');
    return (
      form.getAttribute('data-success-template') ||
      (row && row.getAttribute('data-success-template')) ||
      ''
    );
  }

  function showPasswordSuccess(form, email) {
    var row = form.querySelector('[data-password-email-row]');
    if (row) row.hidden = true;

    var error = form.querySelector('.newsletter-error');
    if (error) error.hidden = true;

    var status = form.querySelector('.newsletter-success');
    if (!status) {
      status = document.createElement('div');
      status.className = 'newsletter-success';
      status.setAttribute('role', 'status');
      form.appendChild(status);
    }
    status.textContent = interpolate(successTemplate(form), email);
    status.hidden = false;
  }

  function showPasswordError(form, message) {
    var error = form.querySelector('.newsletter-error');
    if (!error) {
      error = document.createElement('div');
      error.className = 'newsletter-error';
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    error.textContent = message || ERROR_GENERIC;
    error.hidden = false;
  }

  function showPopupSuccess(form) {
    form.classList.add('is-success');
    var fields = form.querySelectorAll('input:not([type="hidden"]), button[type="submit"]');
    Array.prototype.forEach.call(fields, function (el) {
      el.hidden = true;
    });

    var resp = document.getElementById('newsletterPopupResponse');
    if (!resp) {
      resp = document.createElement('div');
      resp.id = 'newsletterPopupResponse';
      form.appendChild(resp);
    }
    resp.className = 'thanks-message';
    resp.textContent = SUCCESS_POPUP;
    resp.removeAttribute('hidden');
    resp.style.display = '';
    if (getPopup() && getPopup().open) resp.focus({ preventScroll: true });
  }

  function getPopup() {
    return document.getElementById('newsletter-popup');
  }

  var popupTrigger = null;

  function openPopup(trigger) {
    var popup = getPopup();
    if (!popup || popup.open) return;
    popupTrigger = trigger || document.activeElement;
    popup.showModal();
    popup.classList.add('show');
  }

  function closePopup() {
    var popup = getPopup();
    if (!popup || !popup.open) return;
    popup.classList.remove('show');
    popup.close();
  }

  function initPopup() {
    var popup = getPopup();
    if (!popup || popup.dataset.newsletterBound) return;
    popup.dataset.newsletterBound = 'true';
    // Native dialog makes the rest of the page inert and traps keyboard focus.
    // Its close event also covers Escape and browser-driven dismissals.
    popup.addEventListener('close', function () {
      if (popup.open) return;
      popup.classList.remove('show');
      if (popupTrigger && popupTrigger.isConnected) popupTrigger.focus({ preventScroll: true });
      popupTrigger = null;
    });
    popup.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var controls = Array.prototype.filter.call(
        popup.querySelectorAll('button:not(:disabled), input:not([type="hidden"]):not(:disabled), a[href]'),
        function (control) { return control.getClientRects().length > 0; }
      );
      if (!controls.length) return;
      var first = controls[0];
      var last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || controls.indexOf(document.activeElement) === -1)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    popup.addEventListener('cancel', function (event) {
      event.preventDefault();
      closePopup();
    });
    if (popup.hasAttribute('data-newsletter-editor-open')) openPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopup, { once: true });
  } else {
    initPopup();
  }
  document.addEventListener('shopify:section:load', initPopup);

  function setBusy(form, busy) {
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = !!busy;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!isAjaxNewsletter(form)) return;

    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;

    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput && emailInput.value ? emailInput.value.trim() : '';
    if (!email) return;

    setBusy(form, true);
    subscribe(form, false)
      .then(function () {
        if (form.classList.contains('password-inline-form')) {
          showPasswordSuccess(form, email);
        } else {
          showPopupSuccess(form);
        }
      })
      .catch(function () {
        if (form.classList.contains('password-inline-form')) {
          showPasswordError(form, ERROR_GENERIC);
        } else {
          var resp = document.getElementById('newsletterPopupResponse');
          if (resp) {
            resp.className = 'thanks-message';
            resp.textContent = ERROR_GENERIC;
            resp.style.display = '';
          }
        }
      })
      .then(function () {
        setBusy(form, false);
        var submit = form.querySelector('[type="submit"]');
        if (submit && form.querySelector('.newsletter-success, .is-success')) {
          submit.disabled = true;
        }
      });
  });

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('.newsletter-signup')) {
      event.preventDefault();
      openPopup(event.target.closest('.newsletter-signup'));
      return;
    }

    if (event.target.closest('#close-newsletter') || event.target.closest('.close-newsletter')) {
      event.preventDefault();
      closePopup();
      return;
    }

    var popup = getPopup();
    if (popup && event.target === popup) closePopup();
  });

  window.themeNewsletter = {
    subscribe: subscribe,
    open: openPopup,
    close: closePopup
  };
})();
